import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';
import { colors } from '@/lib/analytics/colors';

// Types
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';

export const mediaViewerEngagementConfig: KpiType<
    typeof MediaViewerKpiLoader,
    typeof MediaViewerKPI
> = {
    id: 'engagements',
    name: 'kpi.linkedin.mediaviewer.engagement',
    icon: {
        name: 'engagement-on',
        style: colors.green
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    size: SIZE_50,
    orientation: ORIENTATION_VERTICAL,
    tooltip: null,
    loader: MediaViewerKpiLoader,
    data_format: KPI_VALUE_CLASSIC,
    type: 'kpi',
    element: MediaViewerKPI
};
